// FILE TO UPDATE: src/pages/AdminEventList.jsx (or similar location)

import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  message,
  Popconfirm,
  Image,
  Modal,
  Input,
  Select,
  Form,
} from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

const { Option } = Select;

const AdminEventList = () => {
  const [events, setEvents] = useState([]);
  const [photographers, setPhotographers] = useState([]);
  const [editingEvent, setEditingEvent] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const fetchEvents = async () => {
    try {
      const res = await fetch('http://localhost:5000/admin/events');
      const data = await res.json();
      setEvents(data);
    } catch (err) {
      console.error(err);
      message.error('Failed to fetch events');
    }
  };

  const fetchPhotographers = async () => {
    try {
      const res = await fetch('http://localhost:5000/admin/photographers');
      const data = await res.json();
      setPhotographers(data);
    } catch (err) {
      console.error(err);
      message.error('Failed to fetch photographers');
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(`http://localhost:5000/admin/delete-event/${id}`, {
        method: 'DELETE',
      });
      const result = await res.json();

      if (res.ok) {
        message.success(result.message);
        fetchEvents();
      } else {
        message.error(result.message || 'Failed to delete event');
      }
    } catch (err) {
      console.error(err);
      message.error('Something went wrong');
    }
  };

  const showEditModal = (record) => {
    setEditingEvent(record);
    setIsModalVisible(true);
    form.setFieldsValue({
      event_name: record.event_name,
      photographer_id: record.photographer_id?._id || '',
    });
  };

  const handleEditSave = async () => {
    try {
      const values = await form.validateFields();
      const updatedData = {
        ...values,
      };
      const response = await fetch(`http://localhost:5000/admin/update-event/${editingEvent._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Update failed:', errorText);
        return message.error('Failed to update event');
      }

      const result = await response.json();
      message.success('Event updated successfully!');
      fetchEvents();
      setIsModalVisible(false);
    } catch (error) {
      console.error('Update error:', error);
      message.error('Server error while updating event');
    }
  };

  useEffect(() => {
    fetchEvents();
    fetchPhotographers();
  }, []);

  const columns = [
    {
      title: 'Event Name',
      dataIndex: 'event_name',
      key: 'event_name',
    },
    {
  title: 'Client Name',
  dataIndex: 'client_name',
  key: 'client_name',
},
{
  title: 'Client Contact',
  dataIndex: 'client_contact',
  key: 'client_contact',
},

    {
      title: 'Dates',
      key: 'dates',
      render: (_, record) => (
        <span>
          {record.start_date ? new Date(record.start_date).toLocaleDateString() : 'N/A'} →{' '}
          {record.end_date ? new Date(record.end_date).toLocaleDateString() : 'N/A'}
        </span>
      ),
    },
    {
      title: 'Location',
      dataIndex: 'location',
      key: 'location',
    },
    {
      title: 'Photographer',
      dataIndex: ['photographer_id', 'name'],
      key: 'photographer',
      render: (_, record) => record.photographer_id?.name || 'Not Assigned',
    },
    {
      title: 'Cover Photo',
      dataIndex: 'event_photo',
      key: 'event_photo',
      render: (photo) =>
        photo ? (
          <Image
            width={60}
            src={`http://localhost:5000/uploads/${photo}`}
            alt="Event"
          />
        ) : (
          'No Image'
        ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button
            icon={<EditOutlined />}
            style={{ marginRight: 8 }}
            onClick={() => showEditModal(record)}
          />
          <Popconfirm
            title="Delete this event?"
            onConfirm={() => handleDelete(record._id)}
          >
            <Button type="primary" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h2>All Events</h2>
      <Table
        columns={columns}
        dataSource={events}
        rowKey="_id"
        pagination={{ pageSize: 5 }}
      />

      <Modal
        title="Edit Event"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handleEditSave}
        okText="Update"
      >
        <Form form={form} layout="vertical">
          <Form.Item name="event_name" label="Event Name" rules={[{ required: true }]}> 
            <Input />
          </Form.Item>
          <Form.Item
            name="photographer_id"
            label="Assign Photographer"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select photographer">
              {photographers.map((p) => (
                <Option key={p._id} value={p._id}>
                  {p.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AdminEventList;
